import React from "react";

const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload || !payload.length) return null;

    const value = payload[0].payload.CARR * 1000;
    const currentCarr = (payload[0].value + payload[1].value) * 1000;
    const isNegative = value < 0;
    const labelText = isNegative ? "Decrease" : "Increase";
    const isExistingCarr =
        payload[0].payload.name === "Final" || payload[0].payload.name === "Existing";
    const color = isExistingCarr ? "#156082" : isNegative ? "#00b0f0" : "#e97132";

    return (
        <div style={{ backgroundColor: "#fff", border: "1px solid #ccc", padding: 10 }}>
            <p className="font-bold">{label}</p>
            <p style={{ color: "#156082" }}>{`Current CARR: $${currentCarr.toLocaleString()}`}</p>
            {!isExistingCarr ? (
                <p style={{ color }}>{`${labelText}: $${Math.abs(value).toLocaleString()}`}</p>
            ) : (
                ""
            )}
            {/* <p style={{ color }}>{JSON.stringify(isExistingCarr)}</p> */}
        </div>
    );
};

export default CustomTooltip;
